import { useCallback, useEffect, useState } from 'react';
import { USERS } from '../data/users';

const STORAGE_KEY = 'pbp_logged_user';

function getBaseUrl() {
  if (typeof window === 'undefined') return '';
  return window.location.origin;
}

export function useAuthInternal() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (typeof window === 'undefined') return;

    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) {
        setLoading(false);
        return;
      }
      const parsed = JSON.parse(raw);
      if (parsed && parsed.username) {
        setUser(parsed);
      }
    } catch (_e) {
      // ignorujemy błędy
    } finally {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (username, password) => {
    setError('');

    try {
      const res = await fetch(`${getBaseUrl()}/.netlify/functions/auth-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim(), password }),
      });

      const data = await res.json();

      if (res.ok && data.username) {
        const payload = {
          username: data.username,
          role: data.role,
          firstName: data.firstName,
          lastName: data.lastName,
          position: data.position || 'Pracownik',
          phone: data.phone,
          email: data.email,
        };
        if (typeof window !== 'undefined') {
          window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
          window.sessionStorage.setItem('pbp_show_welcome_modal', '1');
        }
        setUser(payload);
        return true;
      }

      if (res.status === 401 || res.status === 400) {
        setError(data.error || 'Nieprawidłowy login lub hasło.');
        return false;
      }
    } catch (_e) {
      // API niedostępne – fallback do lokalnej listy
    }

    const found = USERS.find(
      (u) => u.username === username && u.password === password
    );

    if (!found) {
      setError('Nieprawidłowy login lub hasło.');
      return false;
    }

    const payload = {
      username: found.username,
      role: found.role,
      firstName: found.firstName,
      lastName: found.lastName,
      position: found.position,
      phone: found.phone,
      email: found.email,
    };

    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      window.sessionStorage.setItem('pbp_show_welcome_modal', '1');
    }

    setUser(payload);
    return true;
  }, []);

  const logout = useCallback(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.removeItem(STORAGE_KEY);
    }
    setUser(null);
  }, []);

  const impersonate = useCallback((targetUser) => {
    if (!targetUser || !targetUser.username) return;
    const payload = {
      username: targetUser.username,
      role: targetUser.role || 'user',
      firstName: targetUser.firstName || '',
      lastName: targetUser.lastName || '',
      position: targetUser.position || '',
      phone: targetUser.phone,
      email: targetUser.email,
    };
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    }
    setUser(payload);
  }, []);

  return {
    user,
    loading,
    error,
    login,
    logout,
    impersonate,
    setError,
  };
}
